import { mobilityOptionsService } from '../../../services/MobilityOption'
import {
  IMobilityCategoriesAndMobilityOptions,
  IMobilityOptionCategoryObject,
  IMobilityOptionObject
} from '../../../types'
import {
  MOBILITY_OPTIONS_CATEGORY_CREATE_FAILURE,
  MOBILITY_OPTIONS_CATEGORY_CREATE_REQUEST,
  MOBILITY_OPTIONS_CATEGORY_CREATE_SUCCESS,
  MOBILITY_OPTIONS_UPDATE_FAILURE,
  MOBILITY_OPTIONS_UPDATE_REQUEST,
  MOBILITY_OPTIONS_UPDATE_SUCCESS,
  MOBILITY_OPTIONS_REMOVE_FAILURE,
  MOBILITY_OPTIONS_REMOVE_REQUEST,
  MOBILITY_OPTIONS_REMOVE_SUCCESS,
  MOBILITY_OPTIONS_CATEGORY_LIST_FAILURE,
  MOBILITY_OPTIONS_CATEGORY_LIST_REQUEST,
  MOBILITY_OPTIONS_CATEGORY_LIST_SUCCESS,
  MOBILITY_OPTIONS_CATEGORY_REMOVE_FAILURE,
  MOBILITY_OPTIONS_CATEGORY_REMOVE_REQUEST,
  MOBILITY_OPTIONS_CATEGORY_REMOVE_SUCCESS,
  MOBILITY_OPTIONS_CREATE_FAILURE,
  MOBILITY_OPTIONS_CREATE_REQUEST,
  MOBILITY_OPTIONS_CREATE_SUCCESS,
  MOBILITY_OPTIONS_LIST_FAIL,
  MOBILITY_OPTIONS_LIST_REQUEST,
  MOBILITY_OPTIONS_LIST_SUCCESS,
  MOBILITY_OPTIONS_SEARCH_FAILURE,
  MOBILITY_OPTIONS_SEARCH_REQUEST,
  MOBILITY_OPTIONS_SEARCH_SUCCESS
} from '../../constants'

// Mobility Options List
export interface IMobilityOptionsListRequest {
  type: MOBILITY_OPTIONS_LIST_REQUEST
}

export interface IMobilityOptionsListSuccess {
  type: MOBILITY_OPTIONS_LIST_SUCCESS
  mobilityOptions: IMobilityOptionObject[]
}

export interface IMobilityOptionsListFail {
  error: string
  type: MOBILITY_OPTIONS_LIST_FAIL
}

// Mobility Options Search
export interface IMobilityOptionsSearchRequest {
  type: MOBILITY_OPTIONS_SEARCH_REQUEST
  query: string
}

export interface IMobilityOptionsSearchSuccess {
  type: MOBILITY_OPTIONS_SEARCH_SUCCESS
  mobilityOptions: IMobilityOptionObject[]
}

export interface IMobilityOptionsSearchFail {
  error: string
  type: MOBILITY_OPTIONS_SEARCH_FAILURE
}

// Mobility Option Create
export interface IMobilityOptionsCreateRequest {
  type: MOBILITY_OPTIONS_CREATE_REQUEST
}

export interface IMobilityOptionsCreateSuccess {
  type: MOBILITY_OPTIONS_CREATE_SUCCESS
  option: IMobilityOptionObject
}

export interface IMobilityOptionsCreateFailure {
  error: string
  type: MOBILITY_OPTIONS_CREATE_FAILURE
}

// Mobility Option Update
export interface IMobilityOptionsUpdateRequest {
  type: MOBILITY_OPTIONS_UPDATE_REQUEST
}

export interface IMobilityOptionsUpdateSuccess {
  type: MOBILITY_OPTIONS_UPDATE_SUCCESS
  option: IMobilityOptionObject
}

export interface IMobilityOptionsUpdateFailure {
  error: string
  type: MOBILITY_OPTIONS_UPDATE_FAILURE
}

// Mobility Option Remove
export interface IMobilityOptionsRemoveRequest {
  type: MOBILITY_OPTIONS_REMOVE_REQUEST
}

export interface IMobilityOptionsRemoveSuccess {
  type: MOBILITY_OPTIONS_REMOVE_SUCCESS
  option: IMobilityOptionObject
}

export interface IMobilityOptionsRemoveFailure {
  error: string
  type: MOBILITY_OPTIONS_REMOVE_FAILURE
}

// Mobility Options Category List
export interface IMobilityOptionsCategoryListRequest {
  type: MOBILITY_OPTIONS_CATEGORY_LIST_REQUEST
}

export interface IMobilityOptionsCategoryListSuccess {
  type: MOBILITY_OPTIONS_CATEGORY_LIST_SUCCESS
  categories: IMobilityOptionCategoryObject[]
}

export interface IMobilityOptionsCategoryListFailure {
  error: string
  type: MOBILITY_OPTIONS_CATEGORY_LIST_FAILURE
}

// Mobility Options Category Create
export interface IMobilityOptionsCategoryCreateRequest {
  type: MOBILITY_OPTIONS_CATEGORY_CREATE_REQUEST
}

export interface IMobilityOptionsCategoryCreateSuccess {
  type: MOBILITY_OPTIONS_CATEGORY_CREATE_SUCCESS
  category: IMobilityOptionCategoryObject
}

export interface IMobilityOptionsCategoryCreateFailure {
  error: string
  type: MOBILITY_OPTIONS_CATEGORY_CREATE_FAILURE
}

// Mobility Options Category Remove
export interface IMobilityOptionsCategoryRemoveRequest {
  type: MOBILITY_OPTIONS_CATEGORY_REMOVE_REQUEST
  id: string
}

export interface IMobilityOptionsCategoryRemoveSuccess {
  type: MOBILITY_OPTIONS_CATEGORY_REMOVE_SUCCESS
}

export interface IMobilityOptionsCategoryRemoveFailure {
  error: string
  type: MOBILITY_OPTIONS_CATEGORY_REMOVE_FAILURE
}

export type IMobilityOptionsAction =
  | IMobilityOptionsListRequest
  | IMobilityOptionsListSuccess
  | IMobilityOptionsListFail
  | IMobilityOptionsSearchRequest
  | IMobilityOptionsSearchSuccess
  | IMobilityOptionsSearchFail
  | IMobilityOptionsCreateRequest
  | IMobilityOptionsCreateSuccess
  | IMobilityOptionsCreateFailure
  | IMobilityOptionsUpdateRequest
  | IMobilityOptionsUpdateSuccess
  | IMobilityOptionsUpdateFailure
  | IMobilityOptionsRemoveRequest
  | IMobilityOptionsRemoveSuccess
  | IMobilityOptionsRemoveFailure
export type IMobilityOptionsCategoryAction =
  | IMobilityOptionsCategoryListRequest
  | IMobilityOptionsCategoryListSuccess
  | IMobilityOptionsCategoryListFailure
  | IMobilityOptionsCategoryCreateRequest
  | IMobilityOptionsCategoryCreateSuccess
  | IMobilityOptionsCategoryCreateFailure
  | IMobilityOptionsCategoryRemoveRequest
  | IMobilityOptionsCategoryRemoveSuccess
  | IMobilityOptionsCategoryRemoveFailure

export type IErrorAction = IMobilityOptionsListFail | IMobilityOptionsSearchFail

// LIST ACTIONS
export function mobilityOptionsListRequest(): IMobilityOptionsListRequest {
  return {
    type: MOBILITY_OPTIONS_LIST_REQUEST
  }
}

export function mobilityOptionsListSuccess(mobilityOptions: IMobilityOptionObject[]): IMobilityOptionsListSuccess {
  return {
    mobilityOptions,
    type: MOBILITY_OPTIONS_LIST_SUCCESS
  }
}

export function mobilityOptionsListFailure(error: string): IMobilityOptionsListFail {
  return {
    error,
    type: MOBILITY_OPTIONS_LIST_FAIL
  }
}

// SEARCH ACTIONS
export function mobilityOptionsSearchRequest(query: string): IMobilityOptionsSearchRequest {
  return {
    type: MOBILITY_OPTIONS_SEARCH_REQUEST,
    query
  }
}

export function mobilityOptionsSearchSuccess(mobilityOptions: IMobilityOptionObject[]): IMobilityOptionsSearchSuccess {
  return {
    mobilityOptions,
    type: MOBILITY_OPTIONS_SEARCH_SUCCESS
  }
}

export function mobilityOptionsSearchFailure(error: string): IMobilityOptionsSearchFail {
  return {
    error,
    type: MOBILITY_OPTIONS_SEARCH_FAILURE
  }
}

// CREATE MOBILITY OPTION
export function mobilityOptionsCreateRequest(): IMobilityOptionsCreateRequest {
  return {
    type: MOBILITY_OPTIONS_CREATE_REQUEST
  }
}

export function mobilityOptionsCreateSuccess(option: IMobilityOptionObject): IMobilityOptionsCreateSuccess {
  return {
    option,
    type: MOBILITY_OPTIONS_CREATE_SUCCESS
  }
}

export function mobilityOptionsCreateFailure(error: string): IMobilityOptionsCreateFailure {
  return {
    error,
    type: MOBILITY_OPTIONS_CREATE_FAILURE
  }
}

// UPDATE MOBILITY OPTION
export function mobilityOptionsUpdateRequest(): IMobilityOptionsUpdateRequest {
  return {
    type: MOBILITY_OPTIONS_UPDATE_REQUEST
  }
}

export function mobilityOptionsUpdateSuccess(option: IMobilityOptionObject): IMobilityOptionsUpdateSuccess {
  return {
    option,
    type: MOBILITY_OPTIONS_UPDATE_SUCCESS
  }
}

export function mobilityOptionsUpdateFailure(error: string): IMobilityOptionsUpdateFailure {
  return {
    error,
    type: MOBILITY_OPTIONS_UPDATE_FAILURE
  }
}

// REMOVE MOBILITY OPTION
export function mobilityOptionsRemoveRequest(): IMobilityOptionsRemoveRequest {
  return {
    type: MOBILITY_OPTIONS_REMOVE_REQUEST
  }
}

export function mobilityOptionsRemoveSuccess(option: IMobilityOptionObject): IMobilityOptionsRemoveSuccess {
  return {
    option,
    type: MOBILITY_OPTIONS_REMOVE_SUCCESS
  }
}

export function mobilityOptionsRemoveFailure(error: string): IMobilityOptionsRemoveFailure {
  return {
    error,
    type: MOBILITY_OPTIONS_REMOVE_FAILURE
  }
}

// CATEGORY LIST ACTIONS
export function mobilityOptionsCategoryListRequest(): IMobilityOptionsCategoryListRequest {
  return {
    type: MOBILITY_OPTIONS_CATEGORY_LIST_REQUEST
  }
}

export function mobilityOptionsCategoryListSuccess(
  categories: IMobilityOptionCategoryObject[]
): IMobilityOptionsCategoryListSuccess {
  return {
    categories,
    type: MOBILITY_OPTIONS_CATEGORY_LIST_SUCCESS
  }
}

export function mobilityOptionsCategoryListFailure(error: string): IMobilityOptionsCategoryListFailure {
  return {
    error,
    type: MOBILITY_OPTIONS_CATEGORY_LIST_FAILURE
  }
}

// CATEGORY CREATE ACTIONS
export function mobilityOptionsCategoryCreateRequest(): IMobilityOptionsCategoryCreateRequest {
  return {
    type: MOBILITY_OPTIONS_CATEGORY_CREATE_REQUEST
  }
}

export function mobilityOptionsCategoryCreateSuccess(
  category: IMobilityOptionCategoryObject
): IMobilityOptionsCategoryCreateSuccess {
  return {
    category,
    type: MOBILITY_OPTIONS_CATEGORY_CREATE_SUCCESS
  }
}

export function mobilityOptionsCategoryCreateFailure(error: string): IMobilityOptionsCategoryCreateFailure {
  return {
    error,
    type: MOBILITY_OPTIONS_CATEGORY_CREATE_FAILURE
  }
}

// CATEGORY REMOVE ACTIONS
export function mobilityOptionsCategoryRemoveRequest(id: string): IMobilityOptionsCategoryRemoveRequest {
  return {
    id,
    type: MOBILITY_OPTIONS_CATEGORY_REMOVE_REQUEST
  }
}

export function mobilityOptionsCategoryRemoveSuccess(): IMobilityOptionsCategoryRemoveSuccess {
  return {
    type: MOBILITY_OPTIONS_CATEGORY_REMOVE_SUCCESS
  }
}

export function mobilityOptionsCategoryRemoveFailure(error: string): IMobilityOptionsCategoryRemoveFailure {
  return {
    error,
    type: MOBILITY_OPTIONS_CATEGORY_REMOVE_FAILURE
  }
}

// Search mobility options using a query
export function searchMobilityOptions(query: string): any {
  return (dispatch: any) => {
    dispatch(mobilityOptionsSearchRequest(query))
    return mobilityOptionsService
      .searchMobilityOptions(query)
      .then(
        (mobilityOptions: any) => dispatch(mobilityOptionsSearchSuccess(mobilityOptions)),
        (error: string) => dispatch(mobilityOptionsSearchFailure(error))
      )
  }
}

export function createMobilityOption(opt: IMobilityOptionObject): any {
  return (dispatch: any) => {
    dispatch(mobilityOptionsCreateRequest())
    return mobilityOptionsService.createMobilityOption(opt).then(
      (opt: IMobilityOptionObject) => {
        dispatch(mobilityOptionsCreateSuccess(opt))
      },
      error => {
        dispatch(mobilityOptionsCreateFailure(error))
        setTimeout(() => {
          dispatch(mobilityOptionsCreateFailure(''))
        }, 5000)
      }
    )
  }
}

export function updateMobilityOption(opt: IMobilityOptionObject): any {
  return (dispatch: any) => {
    dispatch(mobilityOptionsUpdateRequest())
    return mobilityOptionsService.updateMobilityOption(opt).then(
      (opt: IMobilityOptionObject) => {
        dispatch(mobilityOptionsUpdateSuccess(opt))
      },
      error => {
        dispatch(mobilityOptionsUpdateFailure(error))
        setTimeout(() => {
          dispatch(mobilityOptionsUpdateFailure(''))
        }, 5000)
      }
    )
  }
}

export function removeMobilityOption(opt: IMobilityOptionObject): any {
  const copy = Object.assign({}, opt)
  return (dispatch: any) => {
    dispatch(mobilityOptionsRemoveRequest())
    return mobilityOptionsService.removeMobilityOption(opt).then(
      (opt: IMobilityOptionObject) => {
        dispatch(mobilityOptionsRemoveSuccess(copy))
      },
      error => {
        dispatch(mobilityOptionsRemoveFailure(error))
        setTimeout(() => {
          dispatch(mobilityOptionsRemoveFailure(''))
        }, 5000)
      }
    )
  }
}

export function createCategory(name: string): any {
  return (dispatch: any) => {
    dispatch(mobilityOptionsCategoryCreateRequest())
    return mobilityOptionsService.createCategory(name).then(
      (category: IMobilityOptionCategoryObject) => {
        dispatch(mobilityOptionsCategoryCreateSuccess(category))
      },
      error => {
        dispatch(mobilityOptionsCategoryCreateFailure(error))
        setTimeout(() => {
          dispatch(mobilityOptionsCategoryCreateFailure(''))
        }, 5000)
      }
    )
  }
}

export function removeCategory(id: string): any {
  return (dispatch: any) => {
    dispatch(mobilityOptionsCategoryRemoveRequest(id))
    return mobilityOptionsService.removeCategory(id).then(
      () => {
        dispatch(mobilityOptionsCategoryRemoveSuccess())
      },
      error => {
        dispatch(mobilityOptionsCategoryRemoveFailure(error))
        setTimeout(() => {
          dispatch(mobilityOptionsCategoryRemoveFailure(''))
        }, 5000)
      }
    )
  }
}

export const getMobilityCategoriesWithOptions = () => (dispatch: any) => {
  dispatch(mobilityOptionsCategoryListRequest())
  dispatch(mobilityOptionsListRequest())
  return mobilityOptionsService.getMobilityCategoriesWithOptions().then(
    ({ mobilityOptions, mobilityOptionsCategories }: IMobilityCategoriesAndMobilityOptions) => {
      dispatch(mobilityOptionsCategoryListSuccess(mobilityOptionsCategories))
      dispatch(mobilityOptionsListSuccess(mobilityOptions))
    },
    error => {
      dispatch(mobilityOptionsCategoryListFailure(error))
      dispatch(mobilityOptionsListFailure(error))
    }
  )
}

export const getMobilityOptions = () => (dispatch: any) => {
  dispatch(mobilityOptionsListRequest())
  return mobilityOptionsService.getMobilityOptions().then(
    (mobilityOptions: any) => {
      dispatch(mobilityOptionsListSuccess(mobilityOptions))
    },
    error => {
      dispatch(mobilityOptionsListFailure(error))
    }
  )
}

export const getMobilityOptionCategories = () => (dispatch: any) => {
  dispatch(mobilityOptionsCategoryListRequest())
  return mobilityOptionsService.getMobilityOptionCategories().then(
    (mobilityOptionCategories: any) => {
      dispatch(mobilityOptionsCategoryListSuccess(mobilityOptionCategories))
    },
    error => {
      dispatch(mobilityOptionsCategoryListFailure(error))
    }
  )
}



// WEBPACK FOOTER //
// ./src/state/actions/mobility-options/index.ts